import { extend, locale } from 'dayjs';
import 'dayjs/locale/ar';
import 'dayjs/locale/bn';
import 'dayjs/locale/en';
import 'dayjs/locale/en-in';
import 'dayjs/locale/es';
import 'dayjs/locale/hi';
import 'dayjs/locale/tr';
import 'dayjs/locale/ur';
import localeData from 'dayjs/plugin/localeData';

import { getDayjsLang } from './lang';

export function setDayjsLocale(lang: LangType = 'en') {
  extend(localeData);
  locale(getDayjsLang(lang));
}
